module.exports = __webpack_public_path__ + "static/media/diamond.acc908a2.svg";